import React from 'react';

const ChecklistIcon = (props) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 11L12 14L20 6" />
    <path d="M8 6H21" />
    <path d="M8 12H21" />
    <path d="M8 18H21" />
  </svg>
);

export default ChecklistIcon;